
import React from "react"

type Props = {
    isCentral?: boolean,
    invisible?: boolean,
    iconSize?: number
}

export default function SpinnerImage({ isCentral, invisible, iconSize }: Props) {
    let className = "fa fa-spinner fa-spin"
    if (invisible) {
        className += ` invisible`
    }
    if (iconSize) {
        className += ` fa-${iconSize}x`
    }
    let spinnerImage = <i className={className} alt="Loading spinner" />
    if (isCentral) {
        spinnerImage = <div style={{ textAlign: "center" }}>{spinnerImage}</div>
    }
    return spinnerImage
}

SpinnerImage.defaultProps = {
    invisible: false,
    isCentral: false
}
